export default {
  notAllEnvelopesWereCalculated: 'Nie wszystkie koperty zostały obliczone',
  someEnvelopesAreInvalid: 'Niektóre koperty są nieprawidłowe',
  commentRequiredNotPassed: 'Każda koperta, która nie przeszła, wymaga komentarza',
};
